import React from 'react';
import PropTypes from 'prop-types';

const ChevronUp = ({ color = '#B5BDC5' }) => (
    <svg
        width="10px"
        height="10px"
        viewBox="0 0 10 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M5,5.83561589 L8.6707477,2.62371165 C8.87856601,2.44187063 9.19444732,2.46292938 9.37628835,2.6707477 C9.55812937,2.87856601 9.53707062,3.19444732 9.3292523,3.37628835 L5.33451948,6.87167957 C5.2408977,6.95615311 5.12178843,6.99947846 5.00199531,7.00000205 C4.87821157,6.99947846 4.7591023,6.95615311 4.66548052,6.87167957 L0.670747696,3.37628835 C0.46292938,3.19444732 0.441870626,2.87856601 0.623711653,2.6707477 C0.805552679,2.46292938 1.12143399,2.44187063 1.3292523,2.62371165 L5,5.83561589 Z"
                id="chevron-up-path-1"
            />
        </defs>
        <g
            id="Svg-Icons/10px-(All-icons)/no-scale/chevron-up-10px"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2" fill="white">
                <use xlinkHref="#chevron-up-path-1" />
            </mask>
            <use
                id="Mask"
                fill={color}
                transform="translate(5.000000, 4.749998) scale(1, -1) translate(-5.000000, -4.749998) "
                xlinkHref="#chevron-up-path-1"
            />
        </g>
    </svg>
);

ChevronUp.propTypes = {
    color: PropTypes.string,
};

export default ChevronUp;
